export default class ResourseError extends Error {
  constructor(message) {
    super(message);
    this.name = "ResourceError";
  }
}
